import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HaLandingComponent } from './ha-landing/ha-landing.component';
import { PersonalInfoComponent } from './ha-general-info/personal-info/personal-info.component';
import { PrimaryCareComponent } from './ha-general-info/primary-care/primary-care.component';
import { HAMedicalConditionsComponent } from './ha-medical-history/medical-conditions/medical-conditions.component';
import { FamilyHistoryComponent } from './ha-medical-history/family-history/family-history.component';
import { WomenHealthComponent } from './ha-medical-history/women-health/women-health.component';
import { MenHealthComponent } from './ha-medical-history/men-health/men-health.component';
import { ScreeningComponent } from './ha-medical-history/screening/screening.component';
import { SafetyComponent } from './ha-lifestyle/safety/safety.component';
import { SubstanceAbuseComponent } from './ha-lifestyle/substance-abuse/substance-abuse.component';
import { HowYouEatComponent } from './ha-lifestyle/how-you-eat/how-you-eat.component';
import { HowYouMoveComponent } from './ha-lifestyle/how-you-move/how-you-move.component';
import { HowYouThinkComponent } from './ha-lifestyle/how-you-think/how-you-think.component';
import { HowYouSleepComponent } from './ha-lifestyle/how-you-sleep/how-you-sleep.component';
import { WorkLifeBalanceComponent } from './ha-lifestyle/work-life-balance/work-life-balance.component';
import { HealthGoalsComponent } from './ha-lifestyle/health-goals/health-goals.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

const haRoutes: Routes = [
	{
		path: 'info',
		component: HaLandingComponent,
		data: {
			title: 'Health Assessment',
		},
		children: [
			{
				path: 'personal-info',
				component: PersonalInfoComponent,
				outlet: 'general',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'primary-care',
				component: PrimaryCareComponent,
				outlet: 'general',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'medical-condition',
				component: HAMedicalConditionsComponent,
				outlet: 'medical',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'screening',
				component: ScreeningComponent,
				outlet: 'medical',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'men-health',
				component: MenHealthComponent,
				outlet: 'medical',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'women-health',
				component: WomenHealthComponent,
				outlet: 'medical',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'family-history',
				component: FamilyHistoryComponent,
				outlet: 'medical',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'health-goals',
				component: HealthGoalsComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'work-life-balance',
				component: WorkLifeBalanceComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'how-you-sleep',
				component: HowYouSleepComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'how-you-think',
				component: HowYouThinkComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'how-you-move',
				component: HowYouMoveComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'how-you-eat',
				component: HowYouEatComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'substance-abuse',
				component: SubstanceAbuseComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
			{
				path: 'safety',
				component: SafetyComponent,
				outlet: 'lifestyle',
				data: {
					title: 'Health Assessment',
				},
			},
		],
	},
	{
		path: '',
		redirectTo: '/assessment/info',
		pathMatch: 'full',
	},
];

@NgModule({
	providers: [
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false },
		},
	],
	imports: [RouterModule.forChild(haRoutes)],
	exports: [RouterModule],
})
export class HARoutingModule {}
